// Put your applicaiton javascript here
$(function() {
  // Current Ajax request.
  var currentAjaxRequest = null;
  // Grabbing all search forms on the page, and adding a .search-results list to each.
  var searchForms = $('#search_autocomplete').each(function() {
    // Grabbing text input.
    var input = $(this).find('input[name="q"]');
    // Listening to keyup and change on the text field within these search forms.
    input.attr('autocomplete', 'off').bind('keyup change', function() {
      // What's the search term?
      var term = $(this).val();
      // What's the search form?
      var form = $(this).closest('form');
      // What's the search URL?
      var searchURL = '/search?type=product&q=' + term;
      // What's the search results list?
      var resultsList = $('.search-list');
      // If that's a new term and it contains at least 3 characters.
      if (term.length > 3 && term != $(this).attr('data-old-term')) {
        // Saving old query.
        $(this).attr('data-old-term', term);
        // Killing any Ajax request that's currently being processed.
        if (currentAjaxRequest != null) currentAjaxRequest.abort();
        // Pulling results.
        currentAjaxRequest = $.getJSON(searchURL + '&view=json', function(data) {
          // Reset results.
          resultsList.empty();
          // If we have no results.
          if(data.results_count == 0) {
            // resultsList.html('<li><span class="title">No results.</span></li>');
            // resultsList.fadeIn(200);
            resultsList.hide();
          } else {
            var html_output = ''+
              '<div class="result-search flex justify-between pb-4 mb-8">'+
                  '<h3>Produits <span>('+data.results_count+')</span></h3>';
            if(data.results_count > 4) {
              html_output += ''+
                  '<a href="' + searchURL + '" class="btn-link-primary"> Voir tout</a>';
            }
            html_output += ''+
              '</div>'+
              '<div class="grid grid-cols-1 md:grid-cols-4 gap-4 md:gap-8 scrollbar w-full">';
            // If we have results.
            $.each(data.results, function(index, item) {
              if (index > 3) {
                return false;
              }
              html_output += ''+
              '<div class="product flex md:block items-center md:items-start">'+
                  '<div class="img-product mb-4 mr-8 md:mr-0 w-1/2 md:w-auto">'+
                      '<a href="'+item.url+'"><img src="' + item.thumbnail + '" alt=""></a>'+
                  '</div>'+
                  '<div class="desc-product w-1/2 md:w-auto">'+
                      '<a href="'+item.url+'" class="flex flex-col md:flex-row">'+
                          '<h3>' + item.title + '</h3>'+
                          '<div class="product-price text-left md:text-right">'+
                              '<span class="prix">'+item.price+'</span>'+
                          '</div>'+
                      '</a>'+
                  '</div>'+
              '</div>';
            });
            html_output += '</div>';
            resultsList.html(html_output);
            // The Ajax request will return at the most 10 results.
            // If there are more than 10, let's link to the search results page.
            resultsList.fadeIn(200);
          }        
        });
      }
    });
  });
  // Clicking outside makes the results disappear.
  $('body').bind('click', function(){
    $('.search-list').hide();
  });
  $('.close-search').bind('click', function(){
    $('.search-list').hide();
    $('#search_autocomplete').find('input[name="q"]').val('');
  });
  var $select = $('#productSelect');
  $('.variant-link').click(function (e) {
      e.preventDefault();
      $(".variant-li").removeClass('active');
      $(".variant-price").html($(this).data('price'));
      if ($(this).data('price-regular')) {
        $(".variant-price-wrapper").removeClass('hidden');
      }else {
        $(".variant-price-wrapper").addClass('hidden');
      }
      $(this).parent().addClass("active");
      $(".variant-price-regular").html($(this).data('price-regular'));
      $select.val( $(this).data('variant-id') );
      if ($(this).data('price-regular') === "0,00€") {
         document.querySelector('.variant-price-wrapper').style.display = 'none';
      } else {
         document.querySelector('.variant-price-wrapper').style.display = 'inline';
      }

  });
});

/*!
 * accounting.js v0.4.2, copyright 2014 Open Exchange Rates, MIT license, http://openexchangerates.github.io/accounting.js
 */
(function(p,z){function q(a){return!!(""===a||a&&a.charCodeAt&&a.substr)}function m(a){return u?u(a):"[object Array]"===v.call(a)}function r(a){return"[object Object]"===v.call(a)}function s(a,b){var d,a=a||{},b=b||{};for(d in b)b.hasOwnProperty(d)&&null==a[d]&&(a[d]=b[d]);return a}function j(a,b,d){var c=[],e,h;if(!a)return c;if(w&&a.map===w)return a.map(b,d);for(e=0,h=a.length;e<h;e++)c[e]=b.call(d,a[e],e,a);return c}function n(a,b){a=Math.round(Math.abs(a));return isNaN(a)?b:a}function x(a){var b=c.settings.currency.format;"function"===typeof a&&(a=a());return q(a)&&a.match("%v")?{pos:a,neg:a.replace("-","").replace("%v","-%v"),zero:a}:!a||!a.pos||!a.pos.match("%v")?!q(b)?b:c.settings.currency.format={pos:b,neg:b.replace("%v","-%v"),zero:b}:a}var c={version:"0.4.1",settings:{currency:{symbol:"$",format:"%s%v",decimal:".",thousand:",",precision:2,grouping:3},number:{precision:0,grouping:3,thousand:",",decimal:"."}}},w=Array.prototype.map,u=Array.isArray,v=Object.prototype.toString,o=c.unformat=c.parse=function(a,b){if(m(a))return j(a,function(a){return o(a,b)});a=a||0;if("number"===typeof a)return a;var b=b||".",c=RegExp("[^0-9-"+b+"]",["g"]),c=parseFloat((""+a).replace(/\((.*)\)/,"-$1").replace(c,"").replace(b,"."));return!isNaN(c)?c:0},y=c.toFixed=function(a,b){var b=n(b,c.settings.number.precision),d=Math.pow(10,b);return(Math.round(c.unformat(a)*d)/d).toFixed(b)},t=c.formatNumber=c.format=function(a,b,d,i){if(m(a))return j(a,function(a){return t(a,b,d,i)});var a=o(a),e=s(r(b)?b:{precision:b,thousand:d,decimal:i},c.settings.number),h=n(e.precision),f=0>a?"-":"",g=parseInt(y(Math.abs(a||0),h),10)+"",l=3<g.length?g.length%3:0;return f+(l?g.substr(0,l)+e.thousand:"")+g.substr(l).replace(/(\d{3})(?=\d)/g,"$1"+e.thousand)+(h?e.decimal+y(Math.abs(a),h).split(".")[1]:"")},A=c.formatMoney=function(a,b,d,i,e,h){if(m(a))return j(a,function(a){return A(a,b,d,i,e,h)});var a=o(a),f=s(r(b)?b:{symbol:b,precision:d,thousand:i,decimal:e,format:h},c.settings.currency),g=x(f.format);return(0<a?g.pos:0>a?g.neg:g.zero).replace("%s",f.symbol).replace("%v",t(Math.abs(a),n(f.precision),f.thousand,f.decimal))};c.formatColumn=function(a,b,d,i,e,h){if(!a)return[];var f=s(r(b)?b:{symbol:b,precision:d,thousand:i,decimal:e,format:h},c.settings.currency),g=x(f.format),l=g.pos.indexOf("%s")<g.pos.indexOf("%v")?!0:!1,k=0,a=j(a,function(a){if(m(a))return c.formatColumn(a,f);a=o(a);a=(0<a?g.pos:0>a?g.neg:g.zero).replace("%s",f.symbol).replace("%v",t(Math.abs(a),n(f.precision),f.thousand,f.decimal));if(a.length>k)k=a.length;return a});return j(a,function(a){return q(a)&&a.length<k?l?a.replace(f.symbol,f.symbol+Array(k-a.length+1).join(" ")):Array(k-a.length+1).join(" ")+a:a})};if("undefined"!==typeof exports){if("undefined"!==typeof module&&module.exports)exports=module.exports=c;exports.accounting=c}else"function"===typeof define&&define.amd?define([],function(){return c}):(c.noConflict=function(a){return function(){p.accounting=a;c.noConflict=z;return c}}(p.accounting),p.accounting=c)})(this);

/***********  Minicart  ************/

$( "#minicart-content, .cart-section" ).on( "click", ".add", function() {
  $(this).prev().val(+$(this).prev().val() + 1).trigger("change");
});

$( "#minicart-content, .cart-section" ).on( "click", ".sub", function() {
  if ($(this).next().val() > 1) {
    $(this).next().val(+$(this).next().val() - 1).trigger("change");
  }
});

Shopify.onError = function(error) {
  alert('Error: ' + error.message);
}
var currencyFormat = {};
switch(Shopify.currency.active) {
  case "EUR":
		// if currency euro
		currencyFormat = { symbol: Shopify.currency.active,  format: "%v €" };
    break;
  case "GBP":
    // if currency GBP
		currencyFormat = { symbol: Shopify.currency.active,  format: "£ %v" };
		break;
  default:
    // add other currency format hundler here
}
Shopify.onCartUpdate = function(cart) {
  var deleteLabel = "Supprimer" 
	$('#cart-total').html(accounting.formatMoney(cart.total_price/100, currencyFormat));
	$('#cart-subtotal-price').html(accounting.formatMoney(cart.total_price/100, currencyFormat));
	$('#minicart-quantity').html(cart.item_count);
	$('#cart-items').empty();
	if(cart.items.length > 0){
		var itemOutput = "";
		
		$.each(cart.items, function(key, item) {
			itemOutput += '<li class="flex cart-item items-center" id=\"item-'+item.variant_id+'\"><div class="cart-img w-2/4 p-2 cart-item-image mr-8"><a href=\"'+item.url+'\"><img onError=\"this.style.display = \'none\';\" src=\"' + Shopify.resizeImage(item.image, '400x555', 'center') + '\" alt=\"' + item.title + '\" /></a></div><div class="cart-title w-2/4 text-left p-2 cart-item-description"><a class="flex flex-col items-left mb-5" href=\"'+item.url+'\"><h3 class="mb-2 title-product">' + item.title + '</h3><span class="price">' + accounting.formatMoney(item.price/100, currencyFormat) + '</span></a><div class="flex  items-center qty mb-5"><div class="quantity"><a href="#" class="sub"><span class="icon-minus"></span></a><input type="number" class="qty-input" name="quantity" value="' + item.quantity + '" data-min="1" data-max="1000" style="width: 23.7344px;" onchange=\"Shopify.changeItem(' + item.variant_id + ', this.value);\"><a href="#" class="add"><span class="icon-plus-rond"></span></a></div></div><button onclick=\"Shopify.removeItem(' + item.variant_id + ');return false\" class="btn-link-primary delete-product">' + deleteLabel + '</button></div></li>';
	    $('#cart_item_'+item.variant_id+'_price').html(accounting.formatMoney(item.price*item.quantity/100, currencyFormat));
		});
		$('#cart-items').html(itemOutput);
		
		$("#minicart-content").show();
	}
	$('.counter').html(cart.item_count);
  
// ========== DEBUT CROSS-SELL JAVASCRIPT ==========

// Paramètres
var IMAGE_URL = 'https://cdn.shopify.com/s/files/1/0517/4430/9432/files/Encart_Regles_Panier.svg?v=1772432127';

// endo = produit déclencheur (doit être dans le panier)
var TRIGGER_HANDLE = 'endo';

// Produit proposé en cross sell (optionnel mais recommandé pour éviter doublon)
var CROSSSELL_HANDLE = 'pack-endo';

// Variant à ajouter au panier (le variant du cross-sell)
var VARIANT_ID = 15256880316739; // nombre, pas string

var triggerInCart = false;
var crosssellAlreadyInCart = false;

// Vérifie le contenu du panier
$.each(cart.items, function(_, item) {
  // Selon cart.js, le handle est généralement item.handle
  if (item.handle === TRIGGER_HANDLE) triggerInCart = true;
  if (item.handle === CROSSSELL_HANDLE) crosssellAlreadyInCart = true;

  // Sécurité si jamais le thème renvoie différemment
  if (item.product_handle === TRIGGER_HANDLE) triggerInCart = true;
  if (item.product_handle === CROSSSELL_HANDLE) crosssellAlreadyInCart = true;
});

// Supprime un éventuel ancien bloc
$('.crosssell-hollis').remove();

// Affiche uniquement si 9-mois est dans le panier, et si le cross-sell n’y est pas déjà
if (cart.item_count > 0 && triggerInCart && !crosssellAlreadyInCart) {
  var crosssellHTML =
    '<li class="crosssell-hollis" style="list-style:none; margin-top:24px; text-align:center; width:100%; flex:0 0 100% !important;">'
  + '  <div style="width:70%; height:1px; background:#000; opacity:0.25; margin:0 auto 14px auto;"></div>'
  + '  <div class="crosssell-banner" style="pointer-events:none; width:100%; margin:0 auto;">'
  + '    <img src="'+ IMAGE_URL +'" alt="Bloc cross-sell" style="width:100%; height:auto; display:block; border-radius:0; margin:0 auto;">'
  + '  </div>'
  + '  <form action="/cart/add" method="post" onsubmit="event.preventDefault(); addCrosssellToCart('+ VARIANT_ID +');" style="margin-top:14px;">'
  + '    <button type="submit" class="btn-crosssell-cart"'
  + '      style="padding:10px 20px; background:#0B305A; color:#fff; border:none; border-radius:0; font-weight:600; cursor:pointer;">'
  + '      AJOUTER AU PANIER'
  + '    </button>'
  + '  </form>'
  + '</li>';

  $('#cart-items').append(crosssellHTML);
}

// ========== FIN CROSS-SELL JAVASCRIPT ==========

  
}  

function truncateString(str, length) {
  return str.length > length ? str.substring(0, length - 3) + '...' : str
}

Shopify.onItemAdded = function(line_item) { 
  Shopify.getCart(function(cart){
    Shopify.onCartUpdate(cart);
    dataLayer.push({
    event: "add_to_cart",
    gtm: { uniqueEventId: 14, start: 1670406394453, priorityId: 2 },
    eventCallback: "Function",
    eventModel: {
      currency: "EUR",
      source: window.location.pathname,
      items: cart.items,
      value: cart.total_price / 100,
    },
  });
  }); 
}

var Showroom = {
		onVariantChange: function(select) {
			
		},
		updatePrice: function(product_id) {
			
			var field = $('#product-quantity-'+product_id).val();
			var variant_price = parseFloat($('#price-'+product_id).val());
			var variant_compare_price = parseFloat($('#price-compare-'+product_id).val());
			if(variant_price < variant_compare_price){
				var price = accounting.formatMoney((variant_price * field), currencyFormat) + " <del>" + accounting.formatMoney((variant_compare_price * field), currencyFormat) + "</del>";
			} else {
				var price = accounting.formatMoney((variant_price * field), currencyFormat);
			}
			$('#price-field-'+product_id).html(price);
		}
}

window.addEventListener('load resize', function() {
  document.documentElement.style.setProperty('--vh', `${window.innerHeight / 100}px`);
});

